import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { EMPLOYEE_API } from "../apiRoutes";

const mutateAddEmployee = async ({ data }: any) => {
  return await axiosAuth.post(`${EMPLOYEE_API}`, data);
};

const useAddEmployeeMutation = (
  queryParams?: UseMutationOptions<any, Error, { data: any }, unknown>
) =>
  useMutation({
    mutationFn: mutateAddEmployee,
    ...queryParams,
  });

export default useAddEmployeeMutation;
